export default {
  name: 'Login',
  mounted() {
    // このコンポーネントは直接表示されることはなく、
    // router.jsのbeforeEnterフックでAuth0のログインページにリダイレクトされます
  }
};
